<!--
  `#/home/keyboard` — the shortcut reference.

  Rendered from `lib/keymap.ts`'s `BINDINGS`, never transcribed. A hand-written copy is
  guaranteed to drift, which is exactly what happened to the table in
  `docs/annotation_guidelines.md` before it was regenerated — and a shortcut list that lies is
  worse than none, because the annotator concludes the key is broken rather than the page.
-->
<script lang="ts">
  import { bindingsByGroup } from '../lib/keymap';

  const groups = bindingsByGroup();
</script>

<section class="panel col" aria-labelledby="keys-heading" data-section="keyboard">
  <h2 id="keys-heading">Keyboard map</h2>
  <p class="small muted note">
    Rendered from <span class="mono">src/lib/keymap.ts</span> — the same table the workspace's
    key handler matches against — so this list and the behaviour cannot drift apart. Press
    <kbd>?</kbd> anywhere in the workspace for the same thing as an overlay.
  </p>
  <div class="groups">
    {#each groups as [group, bindings] (group)}
      <section class="keygroup">
        <h3>{group}</h3>
        <ul class="keys">
          {#each bindings as binding (binding.action + binding.display)}
            <li data-action={binding.action}>
              <kbd>{binding.display}</kbd>
              <span class="small">{binding.label}</span>
            </li>
          {/each}
        </ul>
      </section>
    {/each}
  </div>
</section>

<style>
  .note {
    margin: 0;
    max-width: 82ch;
  }

  .groups {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 14px;
  }

  .keys {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 5px;
  }

  .keys li {
    display: grid;
    grid-template-columns: 108px 1fr;
    gap: 8px;
    align-items: baseline;
  }
</style>
